import { Checkbox, Form, Select } from 'antd';
import styled from 'styled-components';

export const StyledFormItem = styled(Form.Item)`
  margin-bottom: 24px;

  .date-picker {
    width: 100%;
  }

  .ant-form-item-label {
    padding-bottom: 0px;
    font-weight: bold;

    .anticon {
      margin-left: 5px;
      color: ${props => props.theme.palette.primary.main};
    }
  }

  &.ant-form-item-has-error {
    margin-bottom: 0;
  }

  &.only-label {
    margin-bottom: 12px;

    .ant-form-item-control {
      display: none;
    }
  }
  .ant-input-password {
    padding: 0 0px;
  }
  .ant-input-affix-wrapper:focus,
  .ant-input-affix-wrapper-focused {
    box-shadow: 0 0 0 2px ${props => props.theme.palette.text.purple40} !important;
  }
  .ant-input-affix-wrapper > input.ant-input {
    padding: 0 10px;
  }
  .ant-input-suffix {
    position: absolute;
    z-index: 99;
    top: 35%;
    right: 0;
    padding: 0 10px;
  }

  .ant-input-textarea-show-count::after {
    position: absolute;
    top: -22px;
    right: 0;
    font-size: 14px;
    color: ${props => props.theme.palette.text.primary80};
  }
`;

export const AddGroupDetails = styled.p`
  font-weight: bold;
  font-size: 14px;
  color: ${props => props.theme.palette.text.primary};
`;

export const CounterExtension = styled.span`
  position: absolute;
  top: 0;
  right: 0;
  font-size: 14px;
  color: ${props => props.theme.palette.text.primary80};
`;

export const FormItemSubLabel = styled.p`
  margin-bottom: 20px;
`;

export const CheckboxContainer = styled.div`
  height: 200px;
  overflow-y: auto;
  border: 1px solid ${props => props.theme.palette.border};
  border-radius: 4px;
  margin: -10px 0 10px;
  background: ${props => props.theme.palette.background.light};
`;

export const StyledCheckboxGroup = styled(Checkbox.Group)`
  width: 100%;
`;

export const StyledCheckboxItem = styled.div`
  padding: 8px 20px 8px 15px;
  box-shadow: inset 0px -1px 0px #f4f4f3;
  display: flex;
  align-items: center;
  justify-content: space-between;

  &:hover {
    background: ${props => props.theme.palette.primary.light};
  }

  .delete-icon {
    cursor: pointer;
  }
`;

export const Note = styled.div`
  font-size: 12px;
  font-style: italic;

  .required {
    color: ${props => props.theme.palette.text.attention};
    margin-right: 5px;
  }
`;

export const ErrorText = styled.p`
  font-size: 12px;
  margin-top: -10px;
  color: ${props => props.theme.palette.text.attention};
`;

export const SelectedGroups = styled(Select)`
  .ant-select-selector {
    min-height: 80px !important;
    height: auto !important;

    .ant-select-selection-overflow {
      min-height: 80px;
      height: auto;
      padding: 5px 0;

      &-item {
        align-self: auto;
      }
    }

    input#manualGroups {
      display: none;
    }
  }
`;
